import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {UserService} from "../../services/user.service";
import {TokenStorageService} from "../../services/storage/token-storage.service";

@Component({
    selector: 'app-configurations-page-component2',
    templateUrl: './configurations-page-component2.component.html',
    styleUrls: ['./configurations-page-component2.component.css'],
    standalone: false
})
export class ConfigurationsPageComponent2Component implements OnInit {
  all: String = "*";
  id: any;
  loading: boolean = false;
  name: any;
  code: any;
  publicKey : any;
  appKey : any;
  appSecret : any;
  masterAccountNumber: any;
  openApiEnabled : any;
  fixEnabled : any;
  boApisEnabled : any;
  dwmApiEnabled : any;
  depositAutoApproval : any;
  withdrawAutoApproval : any;
  loadingBankAcc: boolean = false;
  loadingBank: boolean = false;
  isTableEmptyBank: boolean = false;
  isTableEmptyBankAcc: boolean = false;

  isTableEmpty: boolean = false;
  isKeyEmpty: boolean = false;
  instBankList: any;
  topic :String = "General";

  customerDetails: any;
  bankDetails: any;
  loadingCustomerProfile: boolean = false;

  form: FormGroup = new FormGroup({
    publicKey: new FormControl(''),
    appKey: new FormControl(''),
    appSecret: new FormControl(''),
    masterAcc: new FormControl(''),


  });
  instCustomerProfile: any;
  isTableEmptyProfile: boolean = false;
  selectedUserIndex: number = -1;
  customerDetailsCP: any;
  isTableEmptyCP: boolean = false;
  customerName: any;
  selectedUserIndexSP: number = -1;
  loadingSubscriptionPackage: boolean = false;
  isTableEmptyPackage: boolean = false;
  instSubscriptionPackages: any;
  subsPackages: any;
  loadingCP: boolean = false;
  isSelectRowCP: boolean = false;
  isSelectRowSP: boolean = false;
  packageName: any;
  loadingExchanges: boolean = false;
  isTableEmptyExchange: boolean = false;
  Exchanges: any;
  inst :any;
  instDetails: any;
  instDetailsResponse: any;
  isUsersShow: boolean = true;
  isNoCashAccounts: boolean = false;
  isNoSecurityAccounts: boolean = false;
  isNoExchangeAccounts: boolean = false;
  cashAccCount:number=0;
  securityAccCount:number=0;
  exchangeAccCount:number=0;


  element:any
  defaultSubsPckgCount:number=0;
  noDefaultSubsPckgs: boolean = false;

  defaultCustProfilesCount:number=0;
  noDefaultCustProfiles: boolean = false;

  officeTel:any;
  email:any;

  constructor(private toastr: ToastrService,
              private userService: UserService,
              private formBuilder: FormBuilder,
              private tokenStorageService: TokenStorageService,
  ) { }

  ngOnInit(): void {
    this.institutionDetails();

  }

  institutionDetails() {
    this.userService.getInstitutionDetails(this.tokenStorageService.getUser().institution).subscribe(
      {
        next: (data) => {
          if (data.status == 'SUCCESS') {
            this.inst = data;

            this.instDetails = this.initInstDetails(data)

            this.id=this.instDetails[0].institutionId;
            this.code= this.instDetails[0].institutionCode;
            this.name= this.instDetails[0].institutionName;
            this.masterAccountNumber= this.instDetails[0].masterAccountNumber;
            this.publicKey= this.instDetails[0].publicKey;
            this.appKey= this.instDetails[0].appKey;
            this.appSecret= this.instDetails[0].appSecret;
            this.openApiEnabled= this.instDetails[0]?.openApiEnabled;
            this.fixEnabled= this.instDetails[0]?.fixEnabled;
            this.boApisEnabled= this.instDetails[0]?.boApisEnabled;
            this.dwmApiEnabled= this.instDetails[0]?.dwmApiEnabled;
            this.depositAutoApproval= this.instDetails[0]?.depositAutoApproval;
            this.withdrawAutoApproval= this.instDetails[0]?.withdrawAutoApproval;
            this.officeTel = this.instDetails[0]?.officeTel;
            this.email=this.instDetails[0]?.email;

            this.instDetailsResponse = data;

            if(this.inst && this.inst.list && this.inst.list.length <= 0){
              this.isUsersShow = false;
            }

            this.getSelectedInst();
            this.initializeForm();

          } else {

            this.toastr.error(data.reason, "Failed to load data");
          }

        },
        error: (err) => {
          this.loading = false;
          this.toastr.error(err.error.message, "Failed to load data");
        }
      }
    );

  }

  initInstDetails(data: any) {
    var tempData: any = [];
    var temp = {
      institutionId: data?.institution?.institutionId,
      institutionCode: data?.institution?.institutionCode,
      institutionName: data?.institution?.institution,
      masterAccountNumber: data?.institution?.masterAccountNumber,
      officeTel: data?.institution?.officeTel,
      email: data?.institution?.email,
      publicKey:data?.institution?.publicKey,
      appKey: data?.institution?.appKey,
      appSecret: data?.institution?.appSecret,
      openApiEnabled: data?.institution?.openApiEnabled,
      fixEnabled: data?.institution?.fixEnabled,
      boApisEnabled: data?.institution?.boApisEnabled,
      dwmApiEnabled: data?.institution?.dwmApiEnabled,
      depositAutoApproval: data?.institution?.depositAutoApproval,
      withdrawAutoApproval: data?.institution?.withdrawAutoApproval,
    };
    tempData.push(temp);

    return tempData;
  }

  getSelectedInst() {
    if(this.masterAccountNumber== null || this.masterAccountNumber== ''){
      //this.isTableEmpty = true;
      this.isNoCashAccounts = true;
      this.isNoSecurityAccounts= true;
      this.isNoExchangeAccounts = true;
    }

    if (
      this.masterAccountNumber != null ||
      this.masterAccountNumber != ''
    ) {
      this.userService
        .getCustomerAccountDetails(this.masterAccountNumber, 'asia')
        .subscribe((data1: any) => {

          if (data1.status == 'SUCCESS') {
            if (data1.cashAccounts.length) {
              this.isTableEmpty = false;
            } else {
              this.isTableEmpty = true;
            }

            this.customerDetails = data1;

            if(data1.cashAccounts.length==0){
              this.isNoCashAccounts=true;
            }
            data1.cashAccounts.forEach((cashAccount: { securityAccounts: any[]; }) => {
              if (cashAccount.securityAccounts && cashAccount.securityAccounts.length>0) {
                this.securityAccCount += cashAccount.securityAccounts.length;

                cashAccount.securityAccounts.forEach(securityAccount => {
                  if (securityAccount.exchangeAccounts && securityAccount.exchangeAccounts.length>0) {
                    this.exchangeAccCount += securityAccount.exchangeAccounts.length;
                  }
                });
              }

            });

            if(this.securityAccCount == 0){
              this.isNoSecurityAccounts=true;
            }

            if(this.exchangeAccCount == 0){
              this.isNoExchangeAccounts=true;
            }
          } else {
            this.isNoCashAccounts = true;
            this.isNoSecurityAccounts= true;
            this.isNoExchangeAccounts = true;
          }
        });
    } else {
      this.isNoCashAccounts = true;
      this.isNoSecurityAccounts= true;
      this.isNoExchangeAccounts = true;
    }
    this.userService.getInstExchangesList(this.code, 'asia').subscribe((dataE: any) => {
      this.isTableEmptyExchange = false;

      if (dataE.status == 'SUCCESS') {
        this.Exchanges = dataE;

        if (
          this.Exchanges.list == null ||
          this.Exchanges.list.length == 0
        ) {
          this.isTableEmptyExchange = true;
        }
      } else {
        this.isTableEmptyExchange = true;
      }
    });


    this.userService.getBankAccountDetails(this.code , "", 'asia').subscribe((data2: any) => {
      this.isTableEmptyBankAcc = false;

      if (data2.status == 'SUCCESS') {
        this.bankDetails = data2;

        if (
          this.bankDetails.bankAccountList == null ||
          this.bankDetails.bankAccountList.length == 0
        ) {
          this.isTableEmptyBankAcc = true;
        }
      } else {
        this.isTableEmptyBankAcc = true;
      }
    });

    this.userService.getInstBankList(this.code, 'asia').subscribe((data3: any) => {
      this.isTableEmptyBank = false;

      if (data3.status == 'SUCCESS') {
        this.instBankList = data3;

        if (
          this.instBankList.bankList == null ||
          this.instBankList.bankList.length == 0
        ) {
          this.isTableEmptyBank = true;
        }
      } else {
        this.isTableEmptyBank = true;
      }
    });

    this.userService.getInstCustomerProfile(this.code, 'asia').subscribe((data4: any) => {
      console.log('Received data:', data4);
      this.isTableEmptyProfile = false;

      if (data4.status == 'SUCCESS') {
        this.instCustomerProfile = data4;

        if (
          this.instCustomerProfile.profileList == null ||
          this.instCustomerProfile.profileList.length == 0
        ) {
          this.isTableEmptyProfile = true;
        }

        this.instCustomerProfile.profileList.forEach((element: any)=>{
          if(element.isDefault==="YES"){
            this.defaultCustProfilesCount+=1;
          }
        })

        if(this.defaultCustProfilesCount==0){
          this.noDefaultCustProfiles=true;
        }

      } else {
        this.isTableEmptyProfile = true;
      }
    });

    this.userService.getInstSubscriptionPackageList(this.code, 'asia').subscribe((data5: any) => {
      this.isTableEmptyPackage = false;

      if (data5.status == 'SUCCESS') {
        this.instSubscriptionPackages = data5;

        if (
          this.instSubscriptionPackages.packageList == null ||
          this.instSubscriptionPackages.packageList.length == 0
        ) {
          this.isTableEmptyPackage = true;
        }

        this.instSubscriptionPackages.packageList.forEach((element: any)=>{
          if(element.isDefault==="YES"){
            this.defaultSubsPckgCount+=1;
          }
        })

        if(this.defaultSubsPckgCount==0){
          this.noDefaultSubsPckgs=true;
        }

      } else {
        this.isTableEmptyPackage = true;
      }
    });

  }


  selectedRowCP($event:any, customerNumber:any, userInded: number, customerName:any){
    if(userInded === this.selectedUserIndex) {
      this.selectedUserIndex = -1;
      return;
    }
    this.customerName = customerName;
    this.selectedUserIndex = userInded;
    this.isSelectRowCP = true
    this.loadingCP = true;

    this.userService
      .getCustomerDetails(customerNumber, 'asia')
      .subscribe((data1: any) => {

        this.loadingCP = false;
        if (data1.status == 'SUCCESS') {
          if (data1.cashAccounts.length) {
            this.isTableEmptyCP = false;
          } else {
            this.isTableEmptyCP = true;
          }
          this.customerDetailsCP = data1;
        } else {
          this.isTableEmptyCP = true;
        }
      });

  }

  selectedRowSP($event:any, subsPackages:any, userIndedSP: number){
    if(userIndedSP === this.selectedUserIndexSP) {
      this.selectedUserIndexSP = -1;
      return;
    }
    this.packageName = subsPackages.packageName;
    this.selectedUserIndexSP = userIndedSP;
    this.subsPackages = subsPackages;
    this.isSelectRowSP = true

    if(subsPackages.exchangeList.length)
    {
      this.isTableEmpty = false;
    }else{
      this.isTableEmpty = true;
    }


  }

  initializeForm(): void {

    this.form = this.formBuilder.group({
      publicKey: [this.publicKey ? this.publicKey : "-", [Validators.required]],
      appKey: [this.appKey ? this.appKey : "-", [Validators.required]],
      appSecret: [this.appSecret ? "***********" : "-", [Validators.required]],
      openApiEnabled: [this.openApiEnabled, [Validators.required]],
      fixEnabled: [this.fixEnabled, [Validators.required]],
      boApisEnabled: [this.boApisEnabled, [Validators.required]],
      dwmApiEnabled: [this.dwmApiEnabled, [Validators.required]],
      depositAutoApproval: [this.depositAutoApproval, [Validators.required]],
      withdrawAutoApproval: [this.withdrawAutoApproval, [Validators.required]],
    });
  }

  onButtonGroupClick($event: any) {
    let clickedElement = $event.target || $event.srcElement;


    if (clickedElement.nodeName === 'BUTTON') {
      let isCertainButtonAlreadyActive =
        clickedElement.parentElement.querySelector('.active');
      if (isCertainButtonAlreadyActive) {
        isCertainButtonAlreadyActive.classList.remove('active');
      }
      this.topic = $event.target.role;

      if ($event.target.id == 'general') {
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.key-container-content'))).className += ' active';
        (<HTMLElement>(document.querySelector('.key-container-content'))).className += ' show';
      } else if ($event.target.id == 'masterAcc') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.masterAcc-content')).className +=' active';
        (<HTMLElement>document.querySelector('.masterAcc-content')).className +=' show';
      } else if ($event.target.id == 'bankAcc') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=' active';
        (<HTMLElement>document.querySelector('.bankAcc-content')).className +=' show';
      } else if ($event.target.id == 'banks') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.bank-content')).className +=' active';
        (<HTMLElement>document.querySelector('.bank-content')).className +=' show';
      } else if ($event.target.id == 'customer') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.customer-content')).className +=' active';
        (<HTMLElement>document.querySelector('.customer-content')).className +=' show';
      } else if ($event.target.id == 'subscription') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.exchange-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.subscription-content')).className +=' active';
        (<HTMLElement>document.querySelector('.subscription-content')).className +=' show';
      }else if ($event.target.id == 'exchanges') {
        (<HTMLElement>(document.querySelector('.key-container-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.masterAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bankAcc-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.customer-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.bank-content'))).classList.remove('active');
        (<HTMLElement>(document.querySelector('.subscription-content'))).classList.remove('active');
        (<HTMLElement>document.querySelector('.exchange-content')).className +=' active';
        (<HTMLElement>document.querySelector('.exchange-content')).className +=' show';
      }

      clickedElement.className += ' active';
    }
  }

  get formControl(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }


}
